<template>
  <div >
    <div class="box-title">
      {{ $t('Situation.title') }}
    </div>
  <el-row>
    {{ $t('Situation.comparisonBenchmark') }}:
    <el-select v-model="baseLine"  size="small" class="filter-item" :placeholder="$t('Element.selectPlaceholder')"  clearable>
      <el-option  :label="$t('Situation.month')" :value="0" /> 
      <el-option  :label="$t('Situation.period')" :value="1" />   
    </el-select>
  </el-row>
    <p v-if="!chartDataExist" style="font-weight: bold; font-size: 16px; margin-top: 50px;"> {{ $t('Situation.empty') }} </p>  
    <div style="width:100%; height:400px">
      <v-chart
        :option="situationChart"
        
        :update-options="{ notMerge: true}" 
        style="width: 100%; height:100%"
        autoresize />
    </div>
  </div>
</template>
  
 <script>
 // import { mixins } from '@/views/common/mixins.js'

  export default {
    // 用水情形比較
    name: 'Situation',
    data() {
      return {
        chartDataExist: false, // 是否有圖表資料      
        xAxisData: [],
        seriesData: [],
        baseLine:0  //0 :月份 ，1: 期別
      };
    },

    watch: {
      baseLine: function(val) {
      //if (val==0 ) {
        this.baseLine = val
        this.getSituationChart()
      // }
      },
      // 重新載入圖表，文字才會變英文
      '$i18n.locale'() {
        this.getSituationChart()
      }
    },
    async created() {
      this.getSituationChart()
  
    },
    mounted() {
    },
    computed: {
      currentWaterNum() {
        return JSON.parse(localStorage.getItem('currentProfile')).waterNum
      },

      currentWaterId() {
        return JSON.parse(localStorage.getItem('currentProfile')).waterId
      },

      situationChart() {
        let _this = this  
        let option = {
          tooltip: {
            trigger: 'axis',           
          },
          xAxis: {
            type: 'category',            
            data: _this.xAxisData
          },
          yAxis: {
            type: 'value',
            name: this.$t('Situation.flow')
          },   
          dataZoom: [
            {   
              type: 'inside', 
              start: 0,      
              end: 100      
            }
          ],
          series: [
          {
            data: _this.seriesData,
            type: 'bar',
            barWidth : 50,//柱图宽度
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                 return params.data 
              }
            }
          }
        ]
        }
        return option
      }
    },
    methods: {
      // 趨勢圖圖表
    async getSituationChart() {

      if (this.currentWaterId) {

        this.xAxisData = [] // 初始化 很重要!
        this.seriesData = []
       
       //api/report/profile/{waterNum}/waterUsageComparison
       // this.currentWaterNum = 'W-16-0464395' 

        await this.axios.get('/api/report/profile/' + this.currentWaterId + '/waterUsageComparison').then(res => {    
          // console.log('res.data',res.data)                
          this.chartDataExist = true 

           if (Object.keys(res.data).length === 0) {
             this.chartDataExist = false
           }
        
          let month = undefined
          let lastmonth =undefined
          let lastyear =undefined
          let period  = undefined
          let lastperiod = undefined
          let sameyearperiod = undefined
          let lastMonthBilledOn = undefined
          let lastYearBilledOn = undefined
          let lastPeriodBilledOn = undefined
          let sameYearPeriodBilledOn = undefined

          if (this.isNullExceptZero(res.data.month))
            month =res.data.month.toFixed(2)
          
          if (this.isNullExceptZero(res.data.lastmonth))
            lastmonth =res.data.lastmonth.toFixed(2)

          if (this.isNullExceptZero(res.data.lastyear))
            lastyear =res.data.lastyear.toFixed(2)          

          if (this.isNullExceptZero(res.data.period))
            period=res.data.period.toFixed(2)

          if (this.isNullExceptZero(res.data.lastperiod))
            lastperiod =res.data.lastperiod.toFixed(2)

          if (this.isNullExceptZero(res.data.sameyearperiod))
            sameyearperiod =res.data.sameyearperiod.toFixed(2)

            if (this.isNullExceptZero(res.data.lastMonthBilledOn)) {
            lastMonthBilledOn = res.data.lastMonthBilledOn
          } else {
            lastMonthBilledOn = this.$t('Situation.readingRecordingDateEmpty')
          }

          if (this.isNullExceptZero(res.data.lastYearBilledOn)) {
            lastYearBilledOn = res.data.lastYearBilledOn
          } else {
            lastYearBilledOn = this.$t('Situation.readingRecordingDateEmpty')
          }

          if (this.isNullExceptZero(res.data.lastPeriodBilledOn)) {
            lastPeriodBilledOn = res.data.lastPeriodBilledOn
          } else {
            lastPeriodBilledOn = this.$t('Situation.readingRecordingDateEmpty')
          }

          if (this.isNullExceptZero(res.data.sameYearPeriodBilledOn)) {
            sameYearPeriodBilledOn = res.data.sameYearPeriodBilledOn
          } else {
            sameYearPeriodBilledOn = this.$t('Situation.readingRecordingDateEmpty')
          }

          if (this.baseLine==0){
            this.xAxisData.push(
              this.$t('Situation.lastYearMonth')+'('+lastYearBilledOn+')',
              this.$t('Situation.thisMonth'),
              this.$t('Situation.lastMonth')+'('+lastMonthBilledOn+')',
            )
            this.seriesData.push(lastyear,month,lastmonth)
          }
          if (this.baseLine==1){
            this.xAxisData.push(
              this.$t('Situation.lastYearPeriod')+this.$t('Situation.readingRecordingDate', {date: sameYearPeriodBilledOn}),
              this.$t('Situation.thisPeriod'),
              this.$t('Situation.lastPeriod')+this.$t('Situation.readingRecordingDate', {date: lastPeriodBilledOn}),
            )
            this.seriesData.push(sameyearperiod,period,lastperiod)
          } 
          //  console.log('x=',this.xAxisData)
          //  console.log('y=',this.seriesData)
        })        
      } 
    },
      isNullExceptZero(value) {
        return value !== null && value !== undefined && value !== ''
      },
    }
  }
  </script> 